<template>
  <button
    class="bg-pink-700 hover:bg-pink-900 text-white font-bold border border-pink-900 rounded py-2 px-4 w-24 h-12"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Button-component',
  props: {
    disabled: Boolean,
  },
});
</script>

<style lang="scss" scoped></style>
